import { useParams } from 'react-router-dom'

/**
 * Custom hook to get orderId from URL parameters
 * @returns {string} orderId - The order ID from the URL
 */
export const useOrderId = () => {
  const { id: orderId } = useParams()
  return orderId
}
